import React from 'react';
import { Grid, Icon, Card } from 'semantic-ui-react';
import POSButton from 'PointOfSale/modules/common/component/Button';
import ServingOptionSubMenu from 'PointOfSale/modules/servingOptionCategory/container';

import 'PointOfSale/styles/components/button.less';
import 'PointOfSale/styles/components/input.less';
import 'PointOfSale/styles/components/mealsTypes.less';
import 'PointOfSale/styles/components/servingOptions.less';

const ServingOptions = props => {
  const {
    items,
    currentSelectedMenu,
    handleOnClickMenuItem,
    disabled,
    onClickReset,
  } = props;

  return (
    <div className="flex-1 flex flex-col flex-no-wrap">
      <Card fluid className={'flex-1'}>
        <Card.Content>
          <Card.Header textAlign={'left'} className={'titled-card-header'}>
            <label className={'text-orange'}>{'Serving Options'}</label>
          </Card.Header>
          <Grid className="servingOptions-padding">
            <Grid.Row columns="equal">
              {items.map((menu, index) => (
                <Grid.Column key={index}>
                  <POSButton
                    clickHandler={() => {
                      handleOnClickMenuItem(menu.key);
                    }}
                    label={menu.description}
                    selected={menu.selected}
                    disabled={menu.disabled || disabled}
                    fluid
                  />
                </Grid.Column>
              ))}
              <Grid.Column>
                <Icon
                  name="undo"
                  size="large"
                  onClick={onClickReset}
                  className="servingOption-reset-icon"
                />
              </Grid.Column>
            </Grid.Row>
            {(currentSelectedMenu || disabled) && (
              <ServingOptionSubMenu
                currentSelectedMenu={currentSelectedMenu}
                disabled={disabled}
              />
            )}
          </Grid>
        </Card.Content>
      </Card>
    </div>
  );
};

export default ServingOptions;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/component/index.js